export const PESTICIDE_LICENSES_API = '/api/pesticide-licenses';

export const DEFAULT_PAGE_SIZE = 10;
